import { CurrencyPipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { CoreService } from 'src/app/service/core.service';
import { ApiService } from '../../../../../service/api.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import { ExcelService } from '../../../../../service/excel.service';
import * as Chart from 'chart.js';
import { FormGroup, FormControl } from '@angular/forms';


@Component({
  selector: 'app-van-profit-loss',
  templateUrl: './van-profit-loss.component.html',
  styleUrls: ['./van-profit-loss.component.css']
})
export class VanProfitLossComponent implements OnInit {
  filterTypes: { id: string; name: any; }[];
  fileName = 'van_profit_loss.xlsx';
  vans: any;
  pageLoadingImg: boolean;
  report: any;
  country_dec: string;
  rateTyes = [
    { id: 'vanstock_last_tran_rate', name: 'Last Transfer Rate' },
    { id: 'vanstock_avg_tran_rate', name: 'Avg Transfer Rate' }
  ];
  van_id: any;
  period_type: any;
  branch_display_name: any;
  branch_display_code: any;
  branch_address: any;
  exportLoader: boolean;
  van_Dashboard: any;
  dashboard: any;
  selectedTabIndex = 0;
  period_type_dash: any;
  cmpny: any;

  constructor(private apiService: ApiService, private coreService: CoreService, private translate: TranslateService, private excelService: ExcelService, private currencyPipe: CurrencyPipe) { }

  ngOnInit() {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.langChange();
    this.searchVans('');
    this.cmpny = this.coreService.getUserData('cmpny');
    this.country_dec = this.coreService.setDecimalLength();
    this.pageLoadingImg = true;
    this.van_id = 1;
    this.period_type = 't';
    this.period_type_dash = 't';
    let searchval = new FormData();
    searchval.append('period_type', 't');
    searchval.append('van_id', this.van_id);
    this.apiService.vanProfitLossReport(searchval).subscribe((res) => {
      this.report = res.data;
      this.pageLoadingImg = false;
    });

    this.branch_display_name = this.coreService.getUserData('branch_disp_name');
    this.branch_display_code = this.coreService.getUserData('branch_code');
    this.branch_address = this.coreService.getUserData('branch_address');

  }

  ngAfterViewInit() {
    this.dashboard = new FormGroup({});
    this.getDashboard(this.dashboard);
  }

  langChange() {
    this.translate.get(['Common.today', 'Common.last_day', 'Common.last_week', 'Common.last_maonth', 'Common.last_yr', 'Common.cust_date', 'Common.all', 'Common.this_month', 'Common.last_transfer_rate', 'Common.avg_transfer_rate']).subscribe((res: string) => {


      this.filterTypes = [

        { id: 't', name: res['Common.today'] },
        { id: 'ld', name: res['Common.last_day'] },
        { id: 'lw', name: res['Common.last_week'] },
        { id: 'tm', name: res['Common.this_month'] },
        { id: 'lm', name: res['Common.last_maonth'] },
        { id: 'ly', name: res['Common.last_yr'] },
        { id: 'c', name: res['Common.cust_date'] },
        { id: '', name: res['Common.all'] }

      ];
      this.rateTyes = [
        { id: 'vanstock_last_tran_rate', name: res['Common.last_transfer_rate'] },
        { id: 'vanstock_avg_tran_rate', name: res['Common.avg_transfer_rate'] }
      ];
    });
  }

  searchVans(search: string) {
    const searchval = new FormData();
    searchval.append('van_name', search);
    this.apiService.searchVans(searchval).subscribe((res) => {

      this.vans = res['data'];
    });

  }

  vanProfitLoss(formdata: { value: any; }) {
    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }

    console.log("formdata.value");
    console.log(formdata.value);
    
    this.pageLoadingImg = true;

    this.apiService.vanProfitLossReport(formdata.value).subscribe((res) => {
      this.report = res.data;
      this.pageLoadingImg = false;

    });
  }

  vanDashboard(formdata: { value: any; }) {
    if (formdata.value.period_type_dash === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }

    this.apiService.vanDashboardReport(formdata.value).subscribe((res) => {
      this.van_Dashboard = res;
      this.graphRender();
    });
  }

  exportEXCL() {
    this.exportLoader = true;
    this.exportexcel();
  }
  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('export-group');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { raw: true });

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    this.exportLoader = false;

  }

  getDashboard(formdata: { value: any; }) {
    this.apiService.vanDashboardReport(formdata.value).subscribe((res) => {
      this.van_Dashboard = res;
      this.graphRender();

    });
  }

  graphRender() {
    const labels = this.van_Dashboard.map(v => v.van_name);
    const ctx = document.getElementById("van_sale") as HTMLCanvasElement;
    const salesData = this.van_Dashboard.map(v => v.sales_ttl);

    const myChart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          data: salesData,
          backgroundColor: labels.map(() => '#3f9440'),
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        }]
      },
      options: {
        title: {
          display: true,
          text: this.translate.instant('HOME.SALES'),
          fontFamily: "'Inter', sans-serif",
          fontSize: 16,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              minRotation: 90,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
          }]
        }
      }

    });

    const labels1 = this.van_Dashboard.map(v => v.van_name);
    const ctx1 = document.getElementById("van_expenses") as HTMLCanvasElement;
    const salesData1 = this.van_Dashboard.map(v => v.expense_amnt);

    const myChart1 = new Chart(ctx1, {
      type: 'bar',
      data: {
        labels: labels1,
        datasets: [{
          data: salesData1,
          backgroundColor: labels1.map(() => '#c4181e'),
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        }]
      },
      options: {
        title: {
          display: true,
          text: this.translate.instant('Van.Expense'),
          fontFamily: "'Inter', sans-serif",
          fontSize: 16,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              minRotation: 90,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
          }]
        }
      }

    });

    const labels2 = this.van_Dashboard.map(v => v.van_name);
    const ctx2 = document.getElementById("van_profit_anlysis") as HTMLCanvasElement;
    const salesData2 = this.van_Dashboard.map(v => v.net_profit);
    const backgroundColors = salesData2.map(v => v >= 0 ? '#3f9440' : '#c4181e');

    const myChart2 = new Chart(ctx2, {
      type: 'bar',
      data: {
        labels: labels2,
        datasets: [{
          data: salesData2,
          backgroundColor: backgroundColors,
          barPercentage: 0.5,
          categoryPercentage: 0.5,
        }]
      },
      options: {
        title: {
          display: true,
          text: "Van Profit Analysis",
          fontFamily: "'Inter', sans-serif",
          fontSize: 16,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 90,
              minRotation: 90,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontFamily: "'Inter', sans-serif",
              fontSize: 12
            },
          }]
        }
      }

    });
  }

  profitLossVanDet(van_id) {
    this.dashboard = new FormGroup({
      van_id: new FormControl(van_id),
      period_type: new FormControl(this.period_type_dash),
    })

    this.van_id = van_id;
    this.period_type = this.period_type_dash;
    this.vanProfitLoss(this.dashboard);
    this.selectedTabIndex = 1;
  }

}
